import { AppState } from "../app.state";

export const getTranslationsStatus = (state: AppState) => state.i18n.loadStatus;

export const getTranslationsLoaded = (state: AppState) => state.i18n.translationLoaded;
